// This file is only for the app initialization code to access directly.
// Other files may import the read-only version of the config store from `import configStore from 'runtime-config'`

// Shared config/state storage to hold config passed in from the host app
const store = new Map<
  'hostingBasePath' | 'routingBasePath' | 'descopeProjectId',
  string
>();

function initialValues() {
  configStore.hostingBasePath = import.meta.env.BASE_URL; // Vite default base path
  configStore.routingBasePath = import.meta.env.BASE_URL;
  configStore.descopeProjectId = 'no-project-id';
}

/**
 * Setters & reset only really to be used by the app-injector/initializer
 * Getters can be used by any component
 *
 * Did getters/setters instead of a raw map to make it clear what fields are available
 */
export const configStore = {
  /** Descope project ID */
  get descopeProjectId() {
    return store.get('descopeProjectId') ?? 'no-project-id';
  },

  set descopeProjectId(id: string) {
    store.set('descopeProjectId', id);
  },

  /** Base path for where the microfrontend is hosted (base of the deployment URL)
   * This is not to be confused with the base path for React Router routes as the route at which the component is loaded may not be the same as the route at which the actual files are hosted
   * It should be noted for *most* file access import on its own is fine, but for things like routing to `/api` you might need to use this base path since your file structure would be different in development vs production and you can't just use import.meta.resolve('../api') for that
   **/
  get hostingBasePath() {
    return store.get('hostingBasePath') ?? '';
  },

  set hostingBasePath(path: string) {
    store.set('hostingBasePath', path);
  },

  /** Base path for React Router routes */
  get routingBasePath() {
    return store.get('routingBasePath') ?? '';
  },

  set routingBasePath(path: string) {
    store.set('routingBasePath', path);
  },
};

export function reset() {
  store.clear();
  initialValues();
}

initialValues();
